import { AgeVerificationStatus } from "@next-platform/packages-ts-types";
/**
 * Returns true if age verification is optional for the user.
 * @param ageVerificationStatus - current AgeVerificationStatus
 */
export function isAgeVerificationOptional(ageVerificationStatus) {
    // Return true if ageVerificationStatus is set and is not DISABLED, VERIFY, or REVERIFY
    if (ageVerificationStatus &&
        Object.values(AgeVerificationStatus).includes(ageVerificationStatus)) {
        return (ageVerificationStatus !== AgeVerificationStatus.DISABLED &&
            ageVerificationStatus !== AgeVerificationStatus.VERIFY &&
            ageVerificationStatus !== AgeVerificationStatus.REVERIFY);
    }
    return false;
}
